import React from "react";
import { Alert } from "@mui/material";
import logo from "../assets/Logo.jpg"; // ensure the path is correct
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const TokenExpired = () => {

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center px-4">
      <div className="bg-white rounded-3xl shadow-2xl p-8 sm:p-10 w-full max-w-md text-center space-y-4 animate-fade-in">
        {/* Logo */}
        <img
          src={logo}
          alt="Website Logo"
          className="mx-auto rounded-lg"
          style={{ width: 100, height: 100, objectFit: "contain" }}
        />

        {/* Title */}
        <h1 className="text-3xl font-extrabold text-gray-800 tracking-tight">
          Token Expired
        </h1>

        {/* Message */}
        <p className="text-gray-600 text-sm sm:text-base">
          Your invitation link has expired. For security reasons, we only allow access
          for a limited time.
        </p>
<Alert
  severity="error"
  icon={<ErrorOutlineIcon fontSize="small" className="text-red-500 mt-0.5" />}
  className="bg-red-50 border border-red-300 text-sm text-red-800 px-4 py-3 rounded-xl shadow-none"
>
  <span className="font-medium">
    Please request a new invitation link to continue.
  </span>
</Alert>

        {/* Optional Help Text */}
        <p className="text-xs text-gray-400 mt-2">
          Need help? Contact support@example.com
        </p>
      </div>
    </div>
  );
};

export default TokenExpired;
